module["exports"] = [
  "InnoDB",
  "MyISAM",
  "MEMORY",
  "CSV",
  "BLACKHOLE",
  "ARCHIVE"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/database/engine.js
// module id = 377
// module chunks = 0